import React, { useEffect, useRef, useState } from "react";
import "../../../App.css";
import MissAyuPFP from "../../../assets/missayu/MissAyuPFP.PNG";
import IndonesiaFlag from "../../../assets/flags/Indonesia.png";
import UKFlag from "../../../assets/flags/UnitedKingdom.png";
import RedJavaBg from "../../../assets/missayu/RedJavaBg.png";
import LoveAndResults from "../../../assets/missayu/LoveAndResults.png";
import TopImage from "../../../assets/missayu/LEAVES2c.png";
import TopImageDesktop from "../../../assets/missayu/LEAVES1c.png";
import DividerVine from "../../../assets/missayu/Break1.png";
import BottomImage from "../../../assets/missayu/Bottom.png";

// Testimonials
import TestimonialOne from "../../../assets/missayu/testimonials/Adam.mp4";
import TestimonialTwo from "../../../assets/missayu/testimonials/Safira.mp4";
import TestimonialThree from "../../../assets/missayu/testimonials/Satria.mp4";
import TestimonialFour from "../../../assets/missayu/testimonials/Syaifal.mp4";
import TestimonialFive from "../../../assets/missayu/testimonials/Aldino.mp4";
import TestimonialSix from "../../../assets/missayu/testimonials/Daniella.mp4";
import TestimonialSeven from "../../../assets/missayu/testimonials/Paramitha.mp4";
import TestimonialEight from "../../../assets/missayu/testimonials/ElGibbor.mp4";
import TestimonialNine from "../../../assets/missayu/testimonials/Reimbrandt.mp4";
import TestimonialTen from "../../../assets/missayu/testimonials/Sergio.mp4";
import TestimonialEleven from "../../../assets/missayu/testimonials/Feline.mp4";

// Visual Archive
import ArchiveOne from "../../../assets/missayu/visualarchive/a1one.mp4";
import ArchiveTwo from "../../../assets/missayu/visualarchive/a2two.mp4";
import ArchiveThree from "../../../assets/missayu/visualarchive/a3three.mp4";
import ArchiveFour from "../../../assets/missayu/visualarchive/a4four.mp4";
import ArchiveFive from "../../../assets/missayu/visualarchive/a5five.mp4";
import ArchiveSix from "../../../assets/missayu/visualarchive/a6six.mp4";
import ArchiveSeven from "../../../assets/missayu/visualarchive/b1one.mp4";
import ArchiveEight from "../../../assets/missayu/visualarchive/b2two.mp4";
import ArchiveNine from "../../../assets/missayu/visualarchive/b3three.mp4";
import ArchiveTen from "../../../assets/missayu/visualarchive/b4four.mp4";
import ArchiveEleven from "../../../assets/missayu/visualarchive/b5five.mp4";
import ArchiveTwelve from "../../../assets/missayu/visualarchive/b6six.mp4";

const testimonials = [
  { title: "Adam", src: TestimonialOne },
  { title: "Safira", src: TestimonialTwo },
  { title: "Satria", src: TestimonialThree },
  { title: "Syaifal", src: TestimonialFour },
  { title: "Aldino", src: TestimonialFive },
  { title: "Daniella", src: TestimonialSix },
  { title: "Paramitha", src: TestimonialSeven },
  { title: "El Gibbor", src: TestimonialEight },
  { title: "Reimbrandt", src: TestimonialNine },
  { title: "Sergio", src: TestimonialTen },
  { title: "Feline", src: TestimonialEleven },
];

const visualArchive = [
  { title: "Archive One", src: ArchiveOne },
  { title: "Archive Two", src: ArchiveTwo },
  { title: "Archive Three", src: ArchiveThree },
  { title: "Archive Four", src: ArchiveFour },
  { title: "Archive Five", src: ArchiveFive },
  { title: "Archive Six", src: ArchiveSix },
  { title: "Archive Seven", src: ArchiveSeven },
  { title: "Archive Eight", src: ArchiveEight },
  { title: "Archive Nine", src: ArchiveNine },
  { title: "Archive Ten", src: ArchiveTen },
  { title: "Archive Eleven", src: ArchiveEleven },
  { title: "Archive Twelve", src: ArchiveTwelve },
];

const API_BASE =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000"
    : "https://api.pogforts.uk";


const Section = ({ id, kicker, title, children }) => (
  <div id={id} className="missayu-section">
    <div className="missayu-section-header">
      <div className="missayu-kicker">{kicker}</div>
      <h2 className="missayu-title">{title}</h2>
    </div>
    <div className="missayu-content">{children}</div>
  </div>
);

const VineBreak = ({ direction = "left", variant = "one", image = DividerVine }) => (
  <div
    className={`missayu-vine-break missayu-vine-break-${direction} missayu-vine-break-${variant}`}
    aria-hidden="true"
  >
    {image ? (
      <img src={image} alt="" className="missayu-vine-image" />
    ) : (
      <div className="missayu-vine-placeholder" />
    )}
  </div>
);

const VideoGrid = ({ videos, onOpen }) => (
  <div className="missayu-video-grid">
    {videos.map((video) => (
      <button
        key={video.title}
        type="button"
        className="missayu-video-card"
        onClick={() => onOpen(video)}
      >
        <video
            className="missayu-video-thumb"
            src={video.src}
            preload="metadata"
            muted
            playsInline
            controlsList="nodownload"
            disablePictureInPicture
        />

        <div className="missayu-video-play">▶</div>
        <div className="missayu-video-title">{video.title}</div>
      </button>
    ))}
  </div>
);

const MissAyu = () => {
  const [activeVideo, setActiveVideo] = useState(null);
  const modalVideoRef = useRef(null);
  
  const [paymentState, setPaymentState] = useState(null);

  useEffect(() => {
  const snapScript = document.createElement("script");

  snapScript.src =
  process.env.REACT_APP_MIDTRANS_IS_PRODUCTION === "true"
    ? "https://app.midtrans.com/snap/snap.js"
    : "https://app.sandbox.midtrans.com/snap/snap.js";

  snapScript.setAttribute(
    "data-client-key",
    process.env.REACT_APP_MIDTRANS_CLIENT_KEY
  );

  snapScript.async = true;

  document.body.appendChild(snapScript);

  return () => {
    document.body.removeChild(snapScript);
  };
}, []);


useEffect(() => {

  const params = new URLSearchParams(
    window.location.search
  );

  const paymentParam = params.get("payment");

  if (paymentParam) {
    setPaymentState(paymentParam);
  }

}, []);


  // CONTACT FORM
const [formData, setFormData] = useState({
  age: "",
  hours: "",
  subject: "",
  delivery: "",
  studentName: "",
  email: "",
  mobile: "",
});

  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [paymentSummary, setPaymentSummary] = useState(null);
  const [openAgeGroup, setOpenAgeGroup] = useState(null);

  const handleFormChange = (event) => {
  const { name, value } = event.target;

  setFormData((current) => {
    const next = {
      ...current,
      [name]: value,
    };

    if (name === "age" && value === "6-12") {
      next.delivery = "Onsite";
    }

    if (name === "hours" && value === "Taster") {
      next.subject = "Taster";
    }

    if (name === "hours" && value !== "Taster" && current.subject === "Taster") {
      next.subject = "";
    }

    return next;
  });

  setFormError("");
  setFormSuccess("");
};

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const isValidMobile = (mobile) => {
    return /^[0-9+\-\s()]{8,20}$/.test(mobile);
  };

  const handleContactSubmit = async (event) => {
    event.preventDefault();

  if (
  !formData.age ||
  !formData.hours ||
  !formData.subject ||
  !formData.delivery ||
  !formData.studentName ||
  !formData.email ||
  !formData.mobile
    ) {
      setFormError("Please complete all fields before proceeding.");
      return;
    }

    if (!isValidEmail(formData.email)) {
      setFormError("Please enter a valid email address.");
      return;
    }

    if (!isValidMobile(formData.mobile)) {
      setFormError("Please enter a valid mobile number.");
      return;
    }



    try {
  setFormSuccess("Creating secure payment session...");

  const response = await fetch(`${API_BASE}/api/missayu/create-payment`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });

  const data = await response.json();

  


  if (!response.ok) {
    setFormError(data.error || "Unable to create payment session.");
    setFormSuccess("");
    return;
  }

  if (!window.snap) {
  setFormError("Midtrans Snap is not loaded. Please refresh and try again.");
  setFormSuccess("");
  return;
}

const pendingSummary = {
  orderId: data.orderId,
  studentName: formData.studentName,
  age: formData.age,
  hours: formData.hours,
  subject: formData.subject,
  delivery: formData.delivery,
  amount: data.package?.price,
};

localStorage.setItem(
  "missayuPaymentSummary",
  JSON.stringify(pendingSummary)
);

const verifyPaymentStatus = async () => {

  const verifyResponse = await fetch(
    `${API_BASE}/api/missayu/payment-status/${data.orderId}`
  );

  const verifyData = await verifyResponse.json();

  if (!verifyResponse.ok) {
    throw new Error(
      verifyData.error || "Payment verification failed."
    );
  }

  return verifyData;
};

window.snap.pay(data.token, {

  onSuccess: async function (result) {

    try {

      const verified = await verifyPaymentStatus();

      if (
          verified.transactionStatus === "capture" ||
          verified.transactionStatus === "settlement"
      ) {

        setPaymentSummary({
          orderId: data.orderId,
          studentName: formData.studentName,
          age: formData.age,
          hours: formData.hours,
          subject: formData.subject,
          delivery: formData.delivery,
          amount: data.package?.price,
          paymentType: result.payment_type || "unknown",
        });

        setPaymentSuccess(true);

        setFormSuccess(
          "Payment successful. Your lesson booking has been confirmed."
        );

        setFormError("");

        return;
      }

      setFormSuccess(
        `Payment received with status: ${verified.transactionStatus}`
      );

      setFormError("");

    } catch (verifyError) {

      console.error("Verification error:", verifyError);

      setFormError(
        "Payment completed but verification failed. Please contact support."
      );

      setFormSuccess("");
    }
  },

  onPending: async function () {

    try {

      const verified = await verifyPaymentStatus();

      setFormSuccess(
        `Payment pending: ${verified.transactionStatus}. Please complete payment instructions.`
      );

      setFormError("");

    } catch (verifyError) {

      console.error("Pending verification error:", verifyError);

      setFormSuccess(
        "Payment pending. Please complete payment instructions."
      );

      setFormError("");
    }
  },

  onError: function () {

    setFormError("Payment failed. Please try again.");
    setFormSuccess("");
  },

  onClose: function () {

    setFormError("Payment popup closed before completion.");
    setFormSuccess("");
  },
});


} catch (error) {
  console.error("Payment request failed:", error);
  setFormError("Unable to connect to payment server.");
  setFormSuccess("");
}
};


useEffect(() => {

if (paymentState === "finish") {

  const storedSummary = localStorage.getItem(
    "missayuPaymentSummary"
  );

  if (!storedSummary) {

  setFormError(
    "Payment session data was not found."
  );

  setFormSuccess("");

  return;
}

  const parsedSummary = JSON.parse(
    storedSummary
  );

  const verifyRedirectPayment = async () => {

    try {

      const response = await fetch(
        `${API_BASE}/api/missayu/payment-status/${parsedSummary.orderId}`
      );

      const verified = await response.json();

      if (!response.ok) {
        throw new Error(
          verified.error || "Payment verification failed."
        );
      }

      if (
        verified.transactionStatus === "capture" ||
        verified.transactionStatus === "settlement"
      ) {

        setPaymentSummary(parsedSummary);

        setPaymentSuccess(true);

        setFormSuccess(
          "Payment session completed successfully."
        );

        setFormError("");

        localStorage.removeItem(
          "missayuPaymentSummary"
        );

        return;
      }

      setFormSuccess(
        `Payment status: ${verified.transactionStatus || "pending"}`
      );

      setFormError("");

    } catch (error) {

      console.error(
        "Redirect verification failed:",
        error
      );

      setFormError(
        "Unable to verify payment confirmation."
      );

      setFormSuccess("");
    }
  };

  verifyRedirectPayment();
}

if (paymentState === "pending") {

  setFormSuccess(
    "Payment is pending. Please complete the payment instructions."
  );

  setFormError("");
}

if (paymentState === "error") {

  setFormError(
    "Payment failed or expired. Please try again."
  );

  setFormSuccess("");
}

}, [paymentState]);

  const openVideo = (video) => {
    setActiveVideo(video);

    setTimeout(() => {
      if (modalVideoRef.current) {
        modalVideoRef.current.play().catch(() => {});
      }
    }, 50);
  };

  const closeVideo = () => {
    if (modalVideoRef.current) {
      modalVideoRef.current.pause();
      modalVideoRef.current.currentTime = 0;
    }

    setActiveVideo(null);
  };

  return (
    <div
      className="missayu-container"
      style={{ "--missayu-bg": `url(${RedJavaBg})` }}
    >

<div className="missayu-top-art">
  <img
    src={TopImage}
    alt=""
    className="missayu-top-art-image missayu-top-art-mobile"
  />

  <img
    src={TopImageDesktop}
    alt=""
    className="missayu-top-art-image missayu-top-art-desktop"
  />
</div>



      <div className="missayu-shell">
        {/* HERO */}
        <div className="missayu-hero">
          <div className="missayu-avatar">
            <img
              src={MissAyuPFP}
              alt="Miss Ayu"
              className="missayu-avatar-img"
            />
          </div>

          <div className="missayu-hero-text">
            <div className="missayu-kicker">POGFORTS INSTRUCTOR</div>
            <div className="missayu-name-row">
            <h1 className="missayu-name">MISS AYU</h1>

<div className="missayu-flags">
  <div className="flag-tooltip">
    <img src={IndonesiaFlag} alt="Indonesia" />
    <span className="flag-tooltip-text">Indonesia</span>
  </div>

  <div className="flag-tooltip">
    <img src={UKFlag} alt="United Kingdom" />
    <span className="flag-tooltip-text">United Kingdom</span>
  </div>
</div>


        </div>
            

            <p className="missayu-tagline">
              Master of discipline, elegance, and precision.
            </p>
          </div>

          <a href="#contact" className="missayu-contact-button">
            CONTACT
          </a>
        </div>

<Section kicker="LEGEND" title="Teaching Profile">

  <p>
    With over two decades of experience in education, Miss Ayu has operated across multiple
    environments — from private sector training and organisational development to government
    institutions and university-level lecturing. Her work spans roles as a public speaker,
    coach, mentor, and academic contributor, forming a foundation built on communication,
    discipline, and human development.
  </p>

  <p>
    Her core focus lies in the cultivation of soft skills — guiding individuals through
    personal growth, self-awareness, and integrity-driven transformation. Each engagement is
    structured to not only transfer knowledge, but to refine character and elevate mindset.
  </p>

  <p>
    In recent years, her scope has expanded into working with younger learners, including both
    mainstream and neurodivergent students. Through adaptive teaching strategies and inclusive
    methodologies, she has developed the ability to engage diverse learning profiles while
    maintaining precision and control within the learning environment.
  </p>

  <p>
    At the centre of her philosophy is a clear directive: to unlock human potential. Her
    approach integrates education with spiritual grounding and creative expression — ensuring
    that learning resonates beyond intellect, reaching both the mind and the spirit.
  </p>

    {/* IMAGE INSERT */}
  <div className="missayu-inline-image">
    <img src={LoveAndResults} alt="Love and Results" />
  </div>

  <p>
    The result is a learning space engineered for growth — where individuals are equipped not
    only to succeed in structured environments, but to operate with clarity, discipline, and
    purpose in life itself.
  </p>

</Section>

<VineBreak direction="left" variant="one" />

        {/* <Section kicker="SKILLS" title="Core Capabilities"> */}
          {/* <p>Content to be defined.</p> */}
        {/* </Section>  */}

<Section kicker="STYLE" title="Teaching Methodology">
  <p>
    Miss Ayu leads with her heart and steers with a strong mind. She understands that all work
    is meaningless without a clear and passionate goal. In order for students to become
    passionate about learning, teachers themselves must be fully committed to the craft of
    teaching.
  </p>

  <p>
    Understanding her students is always the primary function. This enables her to reach them
    as if by magic, unlocking pathways to growth regardless of their personal circumstances.
    Without true comprehension, no one understands the “why” of education — and the “why” is
    the most important element, not only in study, but in life as a whole.
  </p>

<p>
  Her teaching style has been uniquely refined over time, shaped by a lifetime of working
  alongside Indah Soekotjo — her mentor and mother.
</p>

<div className="missayu-quote-block">
  <div className="missayu-quote-text">
    “I learn as much from my students as they do from me.”
  </div>
  <div className="missayu-quote-author">
    — Indah Soekotjo
  </div>
</div>
</Section>

<VineBreak direction="right" variant="two" />

<Section kicker="SUBJECTS" title="Curriculum">
  <div className="curriculum-tree">

    {/* 6-12 */}
<details
  className="curriculum-node"
  open={openAgeGroup === "6-12"}
  onToggle={(event) => {
    if (event.currentTarget.open) {
      setOpenAgeGroup("6-12");
    }
  }}
>
  <summary>Age 6–12</summary>

  <details className="curriculum-node">
    <summary>12 Hours Maths & English</summary>

    <div className="curriculum-leaf">
      <span>Onsite</span>
      <strong>1,440,000 IDR</strong>
    </div>
  </details>

  <details className="curriculum-node">
    <summary>12 Hours Maths Only</summary>

    <div className="curriculum-leaf">
      <span>Onsite</span>
      <strong>1,440,000 IDR</strong>
    </div>
  </details>

  <details className="curriculum-node">
  <summary>12 Hours English Only</summary>

  <div className="curriculum-leaf">
    <span>Onsite</span>
    <strong>1,440,000 IDR</strong>
  </div>
</details>

  <details className="curriculum-node">
    <summary>5 Hours Maths Only</summary>

    <div className="curriculum-leaf">
      <span>Onsite</span>
      <strong>600,000 IDR</strong>
    </div>
  </details>

  <details className="curriculum-node">
    <summary>5 Hours English Only</summary>

    <div className="curriculum-leaf">
      <span>Onsite</span>
      <strong>600,000 IDR</strong>
    </div>
  </details>
</details>

    {/* 13-18 */}
    <details
  className="curriculum-node"
  open={openAgeGroup === "13-18"}
  onToggle={(event) => {
    if (event.currentTarget.open) {
      setOpenAgeGroup("13-18");
    }
  }}
>
  <summary>Age 13–18</summary>

      <details className="curriculum-node">
        <summary>12 Hours Maths & English</summary>

        <div className="curriculum-leaf">
          <span>Onsite</span>
          <strong>1,440,000 IDR</strong>
        </div>

        <div className="curriculum-leaf">
          <span>Remote</span>
          <strong>1,200,000 IDR</strong>
        </div>
      </details>

      <details className="curriculum-node">
        <summary>12 Hours Maths Only</summary>

        <div className="curriculum-leaf">
          <span>Onsite</span>
          <strong>1,440,000 IDR</strong>
        </div>

        <div className="curriculum-leaf">
          <span>Remote</span>
          <strong>1,200,000 IDR</strong>
        </div>
      </details>

      <details className="curriculum-node">
        <summary>12 Hours English Only</summary>

        <div className="curriculum-leaf">
          <span>Onsite</span>
          <strong>1,440,000 IDR</strong>
        </div>

        <div className="curriculum-leaf">
          <span>Remote</span>
          <strong>1,200,000 IDR</strong>
        </div>
      </details>

      <details className="curriculum-node">
        <summary>5 Hours Maths Only</summary>

        <div className="curriculum-leaf">
          <span>Onsite</span>
          <strong>600,000 IDR</strong>
        </div>

        <div className="curriculum-leaf">
          <span>Remote</span>
          <strong>500,000 IDR</strong>
        </div>
      </details>

      <details className="curriculum-node">
        <summary>5 Hours English Only</summary>

        <div className="curriculum-leaf">
          <span>Onsite</span>
          <strong>600,000 IDR</strong>
        </div>

        <div className="curriculum-leaf">
          <span>Remote</span>
          <strong>500,000 IDR</strong>
        </div>
      </details>
    </details>

    {/* 19+ */}
    <details
  className="curriculum-node"
  open={openAgeGroup === "19+"}
  onToggle={(event) => {
    if (event.currentTarget.open) {
      setOpenAgeGroup("19+");
    }
  }}
>
  <summary>Age 19+</summary>

      <details className="curriculum-node">
        <summary>12 Hours Maths & English</summary>

        <div className="curriculum-leaf">
          <span>Onsite</span>
          <strong>1,440,000 IDR</strong>
        </div>

        <div className="curriculum-leaf">
          <span>Remote</span>
          <strong>1,200,000 IDR</strong>
        </div>
      </details>

      <details className="curriculum-node">
        <summary>12 Hours Maths Only</summary>

        <div className="curriculum-leaf">
          <span>Onsite</span>
          <strong>1,440,000 IDR</strong>
        </div>

        <div className="curriculum-leaf">
          <span>Remote</span>
          <strong>1,200,000 IDR</strong>
        </div>
      </details>

      <details className="curriculum-node">
        <summary>12 Hours English Only</summary>

        <div className="curriculum-leaf">
          <span>Onsite</span>
          <strong>1,440,000 IDR</strong>
        </div>

        <div className="curriculum-leaf">
          <span>Remote</span>
          <strong>1,200,000 IDR</strong>
        </div>
      </details>

      <details className="curriculum-node">
        <summary>5 Hours Maths Only</summary>

        <div className="curriculum-leaf">
          <span>Onsite</span>
          <strong>600,000 IDR</strong>
        </div>

        <div className="curriculum-leaf">
          <span>Remote</span>
          <strong>500,000 IDR</strong>
        </div>
      </details>

      <details className="curriculum-node">
        <summary>5 Hours English Only</summary>

        <div className="curriculum-leaf">
          <span>Onsite</span>
          <strong>600,000 IDR</strong>
        </div>

        <div className="curriculum-leaf">
          <span>Remote</span>
          <strong>500,000 IDR</strong>
        </div>
      </details>
    </details>

    {/* TASTER */}
<details
  className="curriculum-node"
  open={openAgeGroup === "taster"}
  onToggle={(event) => {
    if (event.currentTarget.open) {
      setOpenAgeGroup("taster");
    }
  }}
>
  <summary>Taster</summary>

  <details className="curriculum-node">
    <summary>
      A short taster session to know Miss Ayu and get a feel
      for her teaching methods at your convenience.
    </summary>

    <div className="curriculum-leaf">
      <span>Onsite</span>
      <strong>90,000 IDR</strong>
    </div>

    <div className="curriculum-leaf">
      <span>Remote</span>
      <strong>50,000 IDR</strong>
    </div>
  </details>
</details>
  </div>
</Section>

<VineBreak direction="left" variant="three" />

        <Section kicker="ARCHIVE" title="Visual Archive">
          <VideoGrid videos={visualArchive} onOpen={openVideo} />
        </Section>

<VineBreak direction="right" variant="four" />

<Section kicker="RECORD" title="Testimonials">
  <VideoGrid videos={testimonials} onOpen={openVideo} />
</Section>

<VineBreak direction="left" variant="five" />

<Section id="contact" kicker="ACCESS" title="Contact Form">
  <form className="missayu-contact-form" onSubmit={handleContactSubmit}>
    <div className="missayu-form-grid">
      <label className="missayu-form-field">
        <span>Age Group</span>
        <select name="age" value={formData.age} onChange={handleFormChange}>
          <option value="">Select age group</option>
          <option value="6-12">6–12</option>
          <option value="13-18">13–18</option>
          <option value="19+">19+</option>
        </select>
      </label>

      <label className="missayu-form-field">
        <span>Hours of Study</span>
        <select name="hours" value={formData.hours} onChange={handleFormChange}>
          <option value="">Select hours</option>
          <option value="12 Hours">12 Hours</option>
          <option value="5 Hours">5 Hours</option>
          <option value="Taster">Taster</option>
        </select>
      </label>

      <label className="missayu-form-field">
  <span>Subjects</span>
  <select
    name="subject"
    value={formData.subject}
    onChange={handleFormChange}
    disabled={formData.hours === "Taster"}
  >
    {formData.hours === "Taster" ? (
      <option value="Taster">Taster</option>
    ) : (
      <>
        <option value="">Select subject</option>
        <option value="Maths & English">Maths & English</option>
        <option value="Maths Only">Maths Only</option>
        <option value="English Only">English Only</option>
      </>
    )}
  </select>
</label>

      <label className="missayu-form-field">
  <span>Delivery Method</span>
  <select
    name="delivery"
    value={formData.delivery}
    onChange={handleFormChange}
    disabled={formData.age === "6-12"}
  >
    {formData.age === "6-12" ? (
      <option value="Onsite">Onsite</option>
    ) : (
      <>
        <option value="">Select delivery method</option>
        <option value="Onsite">Onsite</option>
        <option value="Remote">Remote</option>
      </>
    )}
  </select>
</label>

      <label className="missayu-form-field">
        <span>Student Full Name</span>
        <input
          type="text"
          name="studentName"
          value={formData.studentName}
          onChange={handleFormChange}
          placeholder="Enter student full name"
        />
      </label>

      <label className="missayu-form-field">
        <span>Email Address</span>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleFormChange}
          placeholder="Enter contact email"
        />
      </label>

      <label className="missayu-form-field">
        <span>Mobile Number</span>
        <input
          type="tel"
          name="mobile"
          value={formData.mobile}
          onChange={handleFormChange}
          placeholder="Enter mobile number"
        />
      </label>
    </div>

    {formError && <div className="missayu-form-message missayu-form-error">{formError}</div>}
    {formSuccess && <div className="missayu-form-message missayu-form-success">{formSuccess}</div>}

    <button type="submit" className="missayu-form-submit">
      PROCEED TO PAYMENT
    </button>
  </form>
</Section>



        <Section id="future" kicker="FUTURE" title="PLACE HOLDER">
          <p>Marked for future development...</p>
        </Section>
      </div>

      <div className="missayu-bottom-art">
  <img
    src={BottomImage}
    alt=""
    className="missayu-bottom-art-image"
  />
</div>


      {paymentSuccess && paymentSummary && (
  <div className="missayu-success-overlay">
    <div className="missayu-success-modal">

      <div className="missayu-success-kicker">
        PAYMENT CONFIRMED
      </div>

      <h2 className="missayu-success-title">
        Miss Ayu Booking Received
      </h2>

      <div className="missayu-success-grid">

        <div>
          <span>Student</span>
          <strong>{paymentSummary.studentName}</strong>
        </div>

        <div>
          <span>Order ID</span>
          <strong>{paymentSummary.orderId}</strong>
        </div>

        <div>
          <span>Programme</span>
          <strong>
              {paymentSummary.hours === "Taster" &&
              paymentSummary.subject === "Taster"
                ? "Taster Session"
                : `${paymentSummary.hours} • ${paymentSummary.subject}`}
          </strong>
        </div>

        <div>
          <span>Delivery</span>
          <strong>{paymentSummary.delivery}</strong>
        </div>

        <div>
          <span>Status</span>
          <strong>PAID</strong>
        </div>

        <div>
          <span>Amount</span>
          <strong>
            Rp{Number(paymentSummary.amount || 0).toLocaleString("id-ID")}
          </strong>
        </div>

      </div>

      <div className="missayu-success-message">
        Your lesson request has been received successfully.
        Miss Ayu has already been notified directly.
      </div>

      <div className="missayu-onboarding-box">

        <div className="missayu-onboarding-title">
          NEXT STEPS
        </div>

        <ul>
          <li>
            Miss Ayu will review your booking submission.
          </li>

          <li>
            Contact will be made using your submitted email or mobile number.
          </li>

          <li>
            Keep your order ID available for future reference.
          </li>

          <li>
            Session scheduling and onboarding will be arranged directly.
          </li>
        </ul>

      </div>

      <button
        className="missayu-success-close"
        onClick={() => setPaymentSuccess(false)}
      >
        CLOSE
      </button>

    </div>
  </div>
)}


      {activeVideo && (
        <div className="missayu-video-modal" role="dialog" aria-modal="true">
          <button
            type="button"
            className="missayu-video-close"
            onClick={closeVideo}
            aria-label="Close video"
          >
            ×
          </button>

          <video
            ref={modalVideoRef}
            className="missayu-video-expanded"
            src={activeVideo.src}
            controls
            controlsList="nodownload"
            disablePictureInPicture
            playsInline
         />

        </div>
      )}
    </div>
  );
};

export default MissAyu;